(function ($) {
	// On Dom Ready
	$(function () {
		// === Load more records ===
		$(document).on("click", ".loadmore-btn", function (e) {
			e.preventDefault();

			var loadmore_button = $(this);

			var query_args = loadmore_button.data("query_args"),
				current_page = loadmore_button.data("current_page"),
				max_page = loadmore_button.data("max_page");
			console.log({ query_args });
			var data = {
				action: "loadmore",
				security: js_params.ajax_nonce,
				query_args: query_args,
				page: current_page,
			};

			var button_text = loadmore_button.text();

			var listing_element = $(document).find(".posts-list");

			$.ajax({
				url: js_params.ajaxurl,
				data: data,
				type: "POST",
				beforeSend: function (xhr) {
					loadmore_button.text("Loading..."); // change the button text, you can also add a preloader image
				},
				success: function (data) {
					if (data) {
						listing_element.append(data);
						loadmore_button.text(button_text);
						current_page++;

						loadmore_button.data("current_page", current_page);

						if (current_page == max_page) loadmore_button.remove(); // if last page, remove the button

						$(document.body).trigger("posts-loaded");
					} else {
						loadmore_button.remove(); // if no data, remove the button as well
					}
				},
			});
		});


		$(document).on("click", ".loadmore-rel-news-btn", function (e) {
			e.preventDefault();

			var loadmore_button = $(this);

			var pid = loadmore_button.data("pid"),
				paged = loadmore_button.data("page"),
				ppp = loadmore_button.data("max");
			var data = {
				action: "more_rel_news",
				security: js_params.ajax_nonce,
				pid: pid,
				paged: paged,
				ppp: ppp,
			};

			var button_text = loadmore_button.text();

			var listing_element = $(document).find(".tab-news-insights");

			$.ajax({
				url: js_params.ajaxurl,
				data: data,
				type: "POST",
				beforeSend: function (xhr) {
					loadmore_button.text("Loading..."); // change the button text, you can also add a preloader image
				},
				success: function (data) {
					if (data) {
						loadmore_button.remove();
						listing_element.append(data);

					} else {
						loadmore_button.remove(); // if no data, remove the button as well
					}
				},
			});
		});

	});
})(jQuery);
